const ConfirmationModal = ({ message, onConfirm, onCancel, title = 'Are you sure?' }) => (
  <div className="modal-overlay">
    <div className="modal">
      <h3 className="modal-title">{title}</h3>
      <div className="modal-body">
        <p className="modal-text">{message}</p>
      </div>
      <div className="modal-footer">
        <button type="button" onClick={onCancel} className="btn btn-secondary">
          <span className="btn-text">CANCEL</span>
        </button>
        <button type="button" onClick={onConfirm} className="btn btn-danger">
          <span className="btn-text">CONFIRM</span>
        </button>
      </div>
    </div>
  </div>
);

export default ConfirmationModal;
